import fashankyu1 from "./fas-hankyu (1).png";
import fashankyu2 from "./fas-hankyu (2).png";
import fashankyu3 from "./fas-hankyu (3).png";
import fashankyu4 from "./fas-hankyu (4).png";
import fashankyu5 from "./fas-hankyu (5).png";
import fashankyu6 from "./fas-hankyu (6).png";
import fashankyu7 from "./fas-hankyu (7).png";
import fashankyu8 from "./fas-hankyu (8).png";

const fashankyu = [
  fashankyu1,
  fashankyu2,
  fashankyu3,
  fashankyu4,
  fashankyu5,
  fashankyu6,
  fashankyu7,
  fashankyu8,
];

export default fashankyu;
